import store from '@/store.ts';

export default {
	displayList: (state: any) => {
		if (state.storeInputText.length === 0) {
			store.dispatch('updateDisplayListLength', state.list.length);
			return state.list;
		} else {
			const foundItems = state.list.filter((listItem: any) => {
				return listItem.name.toLowerCase().startsWith(state.storeInputText.toLowerCase());
			});

			const secondaryFoundItems = state.list.filter((listItem: any) => {
				return (
					listItem.name.toLowerCase().includes(state.storeInputText.toLowerCase())
					);
			});

			// @ts-ignore
			const finalItems = [...foundItems, ...secondaryFoundItems].unique();
			const finalLength = finalItems.length;


			if (state.activeIdx >= finalLength && finalLength !== 0) {
				store.dispatch('updateActiveIdx', 0);
			}

			store.dispatch('updateDisplayListLength', finalLength);

			return finalItems;
		}
	},
	activeId: (state: any): number => {
		let id = 0;

		if (store.getters.displayList[state.activeIdx] !== undefined) {
			id = store.getters.displayList[state.activeIdx].id;
			store.dispatch('updateActiveId', id);
		}

		return id;
	},
	activeItem: (state: any): any => {
		if (store.getters.displayList[state.activeIdx] !== undefined) {
			return store.getters.displayList[state.activeIdx];
		}
		return {};
	},
	activeName: (state: any): string => {
		let name = '';

		if (store.getters.displayList[state.activeIdx] !== undefined) {
			name = store.getters.displayList[state.activeIdx].name;
		}

		return name;
	},
	activeIdxForWatcher: (state: any) => {
		return state.activeIdx;
	},
	dataPanelOpen: (state: any) => {
		const lists = getCurrLists(state);
		return state.dataPanelSide === 'left' ||
				(state.dataPanelSide === 'right' && lists.length > 0) ||
				(checkIfFilterInputState(state, lists));
	},
};

// @ts-ignore
Array.prototype.unique = function() {
	const a = this.concat();
	for (let i = 0; i < a.length; ++i) {
		for (let j = i + 1; j < a.length; ++j) {
			if (a[i] === a[j]) {
				a.splice(j--, 1);
			}
		}
	}
	return a;
};

function getCurrLists(state: any) {
	if (state.storeInputText.length === 0) {
		return state.list;
	} else {
		const foundItems = state.list.filter((listItem: any) => {
			return listItem.name.toLowerCase().startsWith(state.storeInputText.toLowerCase());
		});

		const secondaryFoundItems = state.list.filter((listItem: any) => {
			return (
				listItem.name.toLowerCase().includes(state.storeInputText.toLowerCase())
				);
		});

		// @ts-ignore
		const finalItems = [...foundItems, ...secondaryFoundItems].unique();
		return finalItems;
	}
}

function checkIfFilterInputState(state: any, list: any[]) {
	let mode;
	if (list.length) {
		mode = list[state.activeIdx].actionType;   
	} else {
		if (state.previewState && state.previewState.actionType) {
			mode = state.previewState.actionType;
		} else {
			mode = null;
		}
	}
	
	return state.dataPanelSide === 'right'
		&& mode === 'Filter'
		&& state.launcherState === 'INPUT';
}
